import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { ViewKey_Edit, ViewKey_View } from '../../../../../consts.js';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
import { EpicFhirAuthModeLabelMap, EpicFhirAuthModes, EpicKeyRingLabelMap, EpicKeyRings } from '@app/org-shared';
const AuthModeDropDown = TS_DropDown.prepareEditable({
    adapter: SimpleListAdapter([...EpicFhirAuthModes], item => _jsx(_Fragment, { children: EpicFhirAuthModeLabelMap[item.item] }))
});
const KeyringDropDown = TS_DropDown.prepareEditable({
    adapter: SimpleListAdapter([...EpicKeyRings], item => _jsx(_Fragment, { children: EpicKeyRingLabelMap[item.item] }))
});
export class Editor_FHIRConfig extends TS_EditableItemComponent {
    render() {
        const fhirConfig = this.state.editable;
        return _jsxs(TS_PropRenderer.Flat, { label: 'FHIR Config', className: 'span-row', children: [this.render_FhirAuthMode(fhirConfig), this.render_Keyring(fhirConfig), this.render_AdvisorClientId(fhirConfig), this.render_AgentClientId(fhirConfig), this.render_FhirAuthURL(fhirConfig), this.render_FhirBaseURL(fhirConfig), this.render_ISS(fhirConfig)] });
    }
    render_FhirAuthMode = (fhirConfig) => {
        const mode = fhirConfig?.item.fhirAuthMode;
        return _jsx(TS_PropRenderer.Flat, { label: 'FHIR Auth Mode', className: 'indent', children: _jsx(Component_SwitchView, { mode: this.props.mode, modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => _jsx("div", { className: 'grid-data', children: mode ? EpicFhirAuthModeLabelMap[mode] : EpicFhirAuthModeLabelMap.cert })
                    },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(AuthModeDropDown, { editable: fhirConfig, prop: 'fhirAuthMode' })
                    }
                ] }) });
    };
    render_Keyring = (fhirConfig) => {
        return _jsx(TS_PropRenderer.Flat, { label: 'Keyring', className: 'indent', children: _jsx(Component_SwitchView, { mode: this.props.mode, modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => _jsx("div", { className: 'grid-data', children: fhirConfig?.item.keyring ? EpicKeyRingLabelMap[fhirConfig.item.keyring] : '-' })
                    },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(KeyringDropDown, { editable: fhirConfig, prop: 'keyring' })
                    }
                ] }) });
    };
    render_AdvisorClientId = (fhirConfig) => {
        return _jsx(TS_PropRenderer.Flat, { label: 'Advisor Client ID', error: fhirConfig?.hasError('advisorClientId'), className: 'indent', children: _jsx(Component_SwitchView, { mode: this.props.mode, modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => _jsx("div", { className: 'grid-data', children: fhirConfig?.item.advisorClientId ?? '-' })
                    },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(DefaultEditor_InputText, { editable: fhirConfig, prop: 'advisorClientId' })
                    }
                ] }) });
    };
    render_AgentClientId = (fhirConfig) => {
        return _jsx(TS_PropRenderer.Flat, { label: 'Agent Client ID', error: fhirConfig?.hasError('agentClientId'), className: 'indent', children: _jsx(Component_SwitchView, { mode: this.props.mode, modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => _jsx("div", { className: 'grid-data', children: fhirConfig?.item.agentClientId ?? '-' })
                    },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(DefaultEditor_InputText, { editable: fhirConfig, prop: 'agentClientId' })
                    }
                ] }) });
    };
    render_FhirAuthURL = (fhirConfig) => {
        return _jsx(TS_PropRenderer.Flat, { label: 'FHIR Auth URL', className: 'indent', children: _jsx(Component_SwitchView, { mode: this.props.mode, modes: [
                    { key: ViewKey_View, renderer: () => _jsx("div", { className: 'grid-data', children: fhirConfig.item.fhirAuthUrl }) },
                    { key: ViewKey_Edit, renderer: () => _jsx(DefaultEditor_InputText, { editable: fhirConfig, prop: 'fhirAuthUrl' }) }
                ] }) });
    };
    render_FhirBaseURL = (fhirConfig) => {
        return _jsx(TS_PropRenderer.Flat, { label: 'FHIR Base URL', className: 'indent', children: _jsx(Component_SwitchView, { mode: this.props.mode, modes: [
                    { key: ViewKey_View, renderer: () => _jsx("div", { className: 'grid-data', children: fhirConfig.item.fhirBaseUrl }) },
                    { key: ViewKey_Edit, renderer: () => _jsx(DefaultEditor_InputText, { editable: fhirConfig, prop: 'fhirBaseUrl' }) }
                ] }) });
    };
    render_ISS = (fhirConfig) => {
        return _jsx(TS_PropRenderer.Flat, { label: 'ISS', className: 'indent', children: _jsx(Component_SwitchView, { mode: this.props.mode, modes: [
                    { key: ViewKey_View, renderer: () => _jsx("div", { className: 'grid-data', children: fhirConfig.item.iss }) },
                    { key: ViewKey_Edit, renderer: () => _jsx(DefaultEditor_InputText, { editable: fhirConfig, prop: 'iss' }) }
                ] }) });
    };
}
//# sourceMappingURL=Editor_FHIRConfig.js.map